import { useCallback } from 'react';
import type { UseFormSetValue, FieldValues } from 'react-hook-form';

export type InitializeFn = (
  details: Array<Record<string, unknown>> | undefined,
  data: Record<string, unknown>
) => void;

const useInitialize = (
  type: string | undefined,
  setValue: UseFormSetValue<FieldValues>
): InitializeFn =>
  useCallback(
    (details = [], data) => {
      const setFormValue = (
        key: string,
        value: unknown,
        detailIndex: number
      ): void => {
        const initializedValue =
          Array.isArray(value) && value.length === 1 ? value[0] : value;

        setValue(`details.${detailIndex}.${key}`, initializedValue);
      };

      details.forEach((dataField, detailIndex) => {
        Object.keys(dataField).forEach((key) => {
          setFormValue(key, dataField[key], detailIndex);
        });
      });

      [
        'value',
        'relativeToLastYear',
        'note',
        'subType',
        'name',
        'description',
        'summary',
        'funnelMetric',
      ].forEach((fieldName) =>
        setValue(fieldName, (data[fieldName] as string) || '')
      );
    },
    [setValue, type]
  );

export default useInitialize;
